import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=4c249ccb&scoped=true&"
import script from "./InviteFriends.vue?vue&type=script&lang=js&"
export * from "./InviteFriends.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/inviteFriends.css?vue&type=style&index=0&id=4c249ccb&scoped=true&lang=css&"
import style1 from "./InviteFriends.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c249ccb",
  null
  
)

export default component.exports